import { OFFERING_ACTIONS as TYPES } from "../../actions/chatbotActions/chatbotActionTypes";

const initialState = {
  chatbotOfferings: [],
  loading: false,
  error: null,
};

const chatBotReducers = (state = initialState, action) => {
  switch (action.type) {
    // FETCH
    case TYPES.FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case TYPES.FETCH_SUCCESS:
      return { ...state, loading: false, chatbotOfferings: action.payload };
    case TYPES.FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // ADD
    case TYPES.ADD_REQUEST:
      return { ...state, loading: true, error: null };
    case TYPES.ADD_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // UPDATE
    case TYPES.UPDATE_REQUEST:
      return { ...state, loading: true, error: null };
    case TYPES.UPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // DELETE
    case TYPES.DELETE_REQUEST:
      return { ...state, loading: true, error: null };
    case TYPES.DELETE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default chatBotReducers;
